module.exports = __webpack_public_path__ + "img/Stage_9_Atmo.a7b34e21.jpg";